module.exports = "/images/71df3217497d980d4c61f1c1f0247152.png";